"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateList = exports.updateField = exports.updateActionInterest = exports.stopMassAction = exports.sherlockCheck = exports.shareList = exports.retryAction = exports.removeList = exports.ignoreRule = exports.getSurveys = exports.getLists = exports.getListItems = exports.getList = exports.getLastAction = exports.getItemActions = exports.getItem = exports.exportList = exports.downloadList = exports.deleteShare = exports.deleteItem = exports.createMassAction = exports.createList = exports.createItemBulk = exports.createItem = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _tokenStorage = _interopRequireDefault(require("./lib/tokenStorage"));

var _api = _interopRequireDefault(require("./api"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var SIXTY_SECONDS = 60000;

var axiosInstance = _axios["default"].create({
  timeout: SIXTY_SECONDS,
  baseURL: process.env.REACT_APP_MASS_PROCESSOR_URL,
  responseType: 'json'
});

axiosInstance.interceptors.request.use(function (request) {
  request.headers.Authorization = _tokenStorage["default"].get();
  return request;
});
axiosInstance.interceptors.response.use(function (response) {
  if (response.data === undefined) return response;
  return response.data;
}, function (error) {
  return Promise.reject(error);
}); // List

var createList = function createList() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Unnamed list' : _ref$name,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'expert' : _ref$type;

  return axiosInstance.post('/list', {
    name: name,
    type: type
  });
}; // @ts-ignore


exports.createList = createList;

var removeList = function removeList(id) {
  return axiosInstance["delete"]('/list/' + id, {
    id: id
  });
};

exports.removeList = removeList;

var getList = function getList(id) {
  return axiosInstance.get('/list/' + id);
};

exports.getList = getList;

var getLists = function getLists() {
  return axiosInstance.get('/list?type=expert');
};

exports.getLists = getLists;

var updateList = function updateList(_ref2) {
  var id = _ref2.id,
      data = _ref2.data;
  return axiosInstance.patch('/list/' + id, data);
};

exports.updateList = updateList;

var shareList = function shareList(_ref3) {
  var id = _ref3.id,
      userId = _ref3.userId,
      email = _ref3.email,
      fullName = _ref3.fullName,
      picture = _ref3.picture,
      currentPosition = _ref3.currentPosition,
      lastName = _ref3.lastName,
      firstName = _ref3.firstName;
  return axiosInstance.post('/list/' + id + '/share', {
    userId: userId,
    email: email,
    fullName: fullName,
    picture: picture,
    currentPosition: currentPosition,
    lastName: lastName,
    firstName: firstName
  });
};

exports.shareList = shareList;

var deleteShare = function deleteShare(_ref4) {
  var id = _ref4.id,
      userId = _ref4.userId;
  return axiosInstance.post('/list/' + id + '/share/delete', {
    userId: userId
  });
}; // Item


exports.deleteShare = deleteShare;

var createItem = function createItem(listId, data) {
  return axiosInstance.post('/item', {
    listId: listId,
    data: data
  });
};

exports.createItem = createItem;

var createItemBulk = function createItemBulk(listId, data) {
  return axiosInstance.post('/item/many', {
    listId: listId,
    data: data
  });
};

exports.createItemBulk = createItemBulk;

var deleteItem = function deleteItem(itemId) {
  return axiosInstance["delete"]("/item/".concat(itemId));
};

exports.deleteItem = deleteItem;

var updateField = function updateField(_ref5) {
  var id = _ref5.id,
      key = _ref5.key,
      value = _ref5.value;
  return axiosInstance.patch('/item/' + id, {
    key: key,
    value: value
  });
}; // Action


exports.updateField = updateField;

var updateActionInterest = function updateActionInterest(_ref6) {
  var id = _ref6.id,
      emailActionId = _ref6.emailActionId,
      interested = _ref6.interested,
      unsubscribed = _ref6.unsubscribed,
      reason = _ref6.reason;
  axiosInstance.put('/action/interest', {
    id: id,
    emailActionId: emailActionId,
    interested: interested,
    unsubscribed: unsubscribed,
    reason: reason
  });
}; // Survey


exports.updateActionInterest = updateActionInterest;

var getSurveys = function getSurveys() {
  return axiosInstance.get('/survey');
};

exports.getSurveys = getSurveys;

var createMassAction = function createMassAction(data) {
  return axiosInstance.post('/mass-action', data);
};

exports.createMassAction = createMassAction;

var ignoreRule = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref7, comment, rules) {
    var listItemId, actionId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            listItemId = _ref7.listItemId, actionId = _ref7.actionId;
            _context.next = 3;
            return axiosInstance.post("/item/".concat(listItemId, "/ignore-rule"), {
              comment: comment,
              actionId: actionId,
              rules: rules
            });

          case 3:
            return _context.abrupt("return", retryAction(actionId));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function ignoreRule(_x, _x2, _x3) {
    return _ref8.apply(this, arguments);
  };
}();

exports.ignoreRule = ignoreRule;

var stopMassAction = function stopMassAction(id) {
  return axiosInstance.post("/mass-action/".concat(id, "/stop"));
};

exports.stopMassAction = stopMassAction;

var retryAction = function retryAction(id) {
  return axiosInstance.post("/action/".concat(id, "/retry"));
};

exports.retryAction = retryAction;

var getListItems = function getListItems(id, offset, itemId) {
  var itemIdSearch = itemId ? "&itemId=".concat(itemId) : '';
  return axiosInstance.get("/list/".concat(id, "/items?offset=") + offset + itemIdSearch);
};

exports.getListItems = getListItems;

var getLastAction = function getLastAction(id) {
  return axiosInstance.get("/item/".concat(id, "/last-action"));
};

exports.getLastAction = getLastAction;

var getItemActions = function getItemActions(id) {
  return axiosInstance.get("/item/".concat(id, "/actions"));
};

exports.getItemActions = getItemActions;

var getItem = function getItem(id) {
  return axiosInstance.get("/item/".concat(id));
};

exports.getItem = getItem;

var sherlockCheck = function sherlockCheck(id) {
  return axiosInstance.get("/item/".concat(id, "/sherlock"));
};

exports.sherlockCheck = sherlockCheck;

var exportList = function exportList(id) {
  return _api["default"].post("/api/export-athena-list/".concat(id)).then(function (response) {
    return response.data;
  });
};

exports.exportList = exportList;

var downloadList = function downloadList(data) {
  var url = data.url.concat("?token=".concat(localStorage.getItem('ngStorage-accessToken')));
  var link = document.createElement('a');
  link.href = url;
  link.download = data.filename;
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

exports.downloadList = downloadList;